import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config';
import Header from '../components/Header';
import SEO from '../components/SEO';
import './BookList.css';

const BookList = () => {
  const [books, setBooks] = useState([]);

  // 获取隐私链接
  const getPrivacyLink = async (imageUrl) => {
    try {
      const response = await fetch(`${BASE_URL}/privacy_link?img_url=${encodeURIComponent(imageUrl)}`);
      const data = await response.json();
      if (typeof data === 'string') {
        return data; // 直接返回URL字符串
      }
      return data.link || data; // 返回link字段或整个响应
    } catch (error) {
      console.error('Error fetching privacy link:', error);
      return imageUrl; // 如果获取失败，返回原始URL
    }
  };

  // 获取书籍数据
  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const response = await fetch(`${BASE_URL}/books`);
        const booksData = await response.json();
        
        // 为每个book对象添加处理后的图片链接
        const booksWithPrivacyLinks = await Promise.all(
          booksData.map(async (book) => {
            const privacyLink = await getPrivacyLink(book.image);
            return {
              ...book,
              privacyImage: privacyLink
            };
          })
        );
        
        setBooks(booksWithPrivacyLinks);
      } catch (error) {
        console.error('Error fetching books:', error);
      }
    };

    fetchBooks();
  }, []);

  return (
    <div className="booklist-container">
      <SEO page="bookList" />
      <div className="page-container">
        <Header />
        <main className="main-content full-width">
          <h1 className="page-title">优质绘本推荐</h1>
          <div className="book-grid">
            {books.map(book => (
              <div key={book.id} className="book-card">
                <img 
                  src={book.privacyImage || '/images/default-img-cover.png'}
                  alt={book.title} 
                  className="book-cover"
                  width="200"
                  height="300"
                  loading="lazy"
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = '/images/default-img-cover.png';
                  }}
                />
                <div className="book-info">
                  <h3 className="book-title">{book.title}</h3>
                  <p className="book-description">{book.description}</p>
                  <div className="book-rating">
                    {Array.from({ length: 5 }).map((_, index) => (
                      <span
                        key={index}
                        className={`star ${index < Math.floor(book.score) ? 'filled' : ''}`}
                      >
                        ★
                      </span>
                    ))}
                    <span className="rating-value">({book.score})</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default BookList;
